import messages from '../../locale/jsonMessages';

const validate = values => {

  const errors = {}

  if (!values.message) {
    errors.message = messages.contactHostError2;
  } else if (values.message && values.message.toString().trim() == '') {
    errors.message = messages.required;
  }


  return errors;
}

export default validate;